import { Button, Checkbox, Col, ConfigProvider, Flex, Row, Space } from "antd"
import FormItem from "antd/es/form/FormItem"
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide"
import FormAntd from "components/form/FormProvide/FormAntd"
import FormSwitch from "components/form/FormProvide/FormSwitch"
import FormTimePicker from "components/form/FormProvide/FormTimePicker"
import { useTranslation } from "react-i18next"
import dayjs from "dayjs"
import { useForm } from "antd/es/form/Form"
import { useEffect } from "react"

const AddTimesheetForm = ({
    TaskOptions = [],
    onUpdateTimesheet = () => { },
    initialValues = [],
    setActivePanel = () => { },
    timesheetOptions = [],
    roleOptions = [],
    taskOptions = [],
    onProjectChange = () => { },
    onRoleChange = () => { },
    editRecord,
    onCancel = () => { },
    setIsModalOpen = () => { },
    calendarUpdate = false
}) => {
    const { t } = useTranslation();
    const [form] = useForm();

    // const transformedInitialValues = initialValues
    //     ? {
    //         ...initialValues,
    //         recordingDate: initialValues?.recordingDate ? dayjs(initialValues.recordingDate) : null,
    //         totalWorkingHours:
    //             dayjs()
    //                 .hour(initialValues?.totalWorkingHours || 0)
    //                 .minute(initialValues?.totalWorkingMinutes || 0),
    //         billableFlag: initialValues?.billableFlag === "Y" || initialValues?.billable,
    //         reworkFlag: initialValues?.reworkFlag === "Y" || initialValues?.reworkFlag,
    //         timeSheetId: initialValues?.projectId || initialValues?.timeSheetId,
    //         roleId: initialValues?.role?.id || initialValues?.roleId,
    //         taskId: initialValues?.subtaskId || initialValues?.taskId,
    //         description: initialValues?.description || ""
    //     }
    //     : {};

    const transformedInitialValues = initialValues
        ? {
            recordingDate: initialValues?.recordingDate ? dayjs(initialValues.recordingDate) : null,
            totalWorkingHours: dayjs()
                .hour(initialValues?.totalWorkingHours || 0)
                .minute(initialValues?.totalWorkingMinutes || 0),
            billableFlag: initialValues?.billableFlag === "Y",
            reworkFlag: initialValues?.reworkFlag === "Y",
            timeSheetId: initialValues?.projectId || initialValues?.timeSheetId,
            roleId: initialValues?.role?.id || initialValues?.roleId || initialValues?.stpTimeSheetRoleId,
            taskId: initialValues?.subtaskId || initialValues?.taskId,
            description: initialValues?.description || "",
            txnMyTimeSheetId: initialValues?.txnMyTimeSheetId,
            projectId: initialValues?.projectId,
        }
        : {};

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(transformedInitialValues);
        }
    }, [initialValues]);

    useEffect(() => {
        if (editRecord && initialValues?.projectId) {
            onProjectChange(initialValues?.projectId);
            onRoleChange(initialValues?.roleId)
        }
    }, [editRecord, initialValues?.projectId, initialValues?.roleId, onProjectChange, onRoleChange]);

    return (
        <FormAntd
            form={form}
            onFinish={async (values) => {
                try {
                    await onUpdateTimesheet(values);
                    form.resetFields();
                    setActivePanel(null);
                    setIsModalOpen(false);
                } catch (error) {
                }
            }}
            initialValues={transformedInitialValues}
        >
            <FormItem shouldUpdate={(prev, curv) => {
                return false
            }}>
                {({ getFieldValue, setFieldValue, resetFields }) => {
                    return (
                        <Space direction="vertical" size={32} style={{ width: "100%" }}>
                            <Flex vertical gap={16}>
                                <Row gutter={32} style={{ marginLeft: "0px" }}>
                                    <Col span={12}>
                                        <FormDatePicker
                                            name="recordingDate"
                                            label={t("my_timesheet.label.dateTimeRecord")}
                                            placeholder={t("report.please_select")}
                                            size="large"
                                            required
                                            disabled={editRecord || calendarUpdate}
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <FormTimePicker
                                            name="totalWorkingHours"
                                            label={t("workin.work-time")}
                                            placeholder={t('report.please_select')}
                                            size="large"
                                            minuteStep={30}
                                            required
                                            showNow={false}
                                        />
                                    </Col>
                                </Row>

                                <Row gutter={32} style={{ marginLeft: "0px" }}>
                                    <Col span={12}>
                                        <FormSelect
                                            name="timeSheetId"
                                            label={t("my_timesheet.label.select_proj")}
                                            placeholder={t('report.please_select')}
                                            size="large"
                                            required
                                            options={timesheetOptions}
                                            onChange={(value) => {
                                                setFieldValue("roleId", undefined);
                                                setFieldValue("taskId", undefined);
                                                onProjectChange(value);
                                            }}
                                            disabled={calendarUpdate}
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <FormSelect
                                            name="roleId"
                                            label={t("my_timesheet.label.select_role")}
                                            placeholder={t('report.please_select')}
                                            size="large"
                                            required
                                            options={roleOptions}
                                            onChange={(value) => {
                                                setFieldValue("taskId", undefined);
                                                onRoleChange(value);
                                            }}
                                            disabled={calendarUpdate}
                                        />
                                    </Col>
                                </Row>

                                <Row gutter={32} style={{ marginLeft: "0px" }}>
                                    <Col span={12}>
                                        <FormSelect
                                            name="taskId"
                                            label={t("my_timesheet.label.select_task")}
                                            placeholder={t('report.please_select')}
                                            size="large"
                                            required
                                            options={taskOptions}
                                            tree={true}
                                            disableNonLeaf={true}
                                            disabled={calendarUpdate}
                                        />
                                    </Col>
                                    <Col span={12} style={{ alignContent: "end" }}>
                                        <Row>
                                            <Col span={12} style={{ paddingLeft: "0px" }}>
                                                <Flex gap={16} align="center">
                                                    <FormSwitch name="billableFlag" />
                                                    <span>{t("my_timesheet.label.billable")}</span>
                                                </Flex>
                                            </Col>
                                            <Col span={12} style={{ paddingLeft: "0px", alignContent: "center" }}>
                                                <FormItem name="reworkFlag" valuePropName="checked">
                                                    <Checkbox >{t("my_timesheet.label.re_work")}</Checkbox>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row gutter={32} style={{ marginLeft: "0px" }}>
                                    <Col span={24}>
                                        <FormInput
                                            name="description"
                                            label={t("employee.label.description")}
                                            placeholder={t("common.explain_further")}
                                            size="large"
                                            required
                                            type="textArea"
                                            rows={2}
                                        />
                                    </Col>
                                </Row>
                            </Flex>
                            <Row gutter={24} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                <Button
                                    type="default"
                                    onClick={() => {
                                        resetFields();
                                        setActivePanel(null);
                                        onCancel();
                                    }}
                                    style={{ borderRadius: "8px" }} size="large"
                                >
                                    {t("common.cancel").toUpperCase()}
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                                    size="large"
                                >
                                    {t("common.save_draft").toUpperCase()}
                                </Button>
                            </Row>
                        </Space>
                    )
                }}
            </FormItem>
        </FormAntd>
    )
}

export default AddTimesheetForm;